import { CompanyApi, InvoiceDetailsApi } from "../../../../../../../../../services/Api/Organization/types";

export const checkIfCanRenderInvoiceForm = (invoiceDetails?: InvoiceDetailsApi, companyInfo?: CompanyApi) => {
	let result = true;
	if (!invoiceDetails || (invoiceDetails && Object.keys(invoiceDetails).length === 0)) result = false;
	if (!companyInfo || !companyInfo.company_name || !companyInfo.tax_id_no) result = false;
	return result;
};

export const checkIfRenderNoInvoiceDetailsAlert = (invoiceDetails?: InvoiceDetailsApi) => {
	return !invoiceDetails || (invoiceDetails && Object.keys(invoiceDetails).length === 0);
};

export const checkIfRenderNotFullCompanyInfo = (companyInfo?: CompanyApi) => {
	return !companyInfo || Object.keys(companyInfo).length === 0 || !companyInfo.company_name || !companyInfo.tax_id_no;
};
